import {Controller} from "stimulus";

export default class extends Controller {
  static targets = ["check", "completed"];

  initialize() {
    this.token = document.head.querySelector("[name=csrf-token]").content;
    console.log('hello from concierge todo');
  }

  toggleComplete(event) {
    event.preventDefault();
    event.cancelBubble = true;
    if (this.checkTarget.classList.contains('complete')) {
      this.sendStatus('DELETE');
    }
    else {
      this.sendStatus('PUT');
    }
  }

  /*
  completed(check) {
    check.classList.toggle('complete', true);
    $.ajax({
      url: this.data.get('url'),
      type: 'PUT',
      data: {authenticity_token: $('meta[name=csrf-token]').attr('content')}
    });
  }

  incompleted(check) {
    check.classList.toggle('complete', false);
    $.ajax({
      url: this.data.get('url'),
      type: 'DELETE',
      data: {authenticity_token: $('meta[name=csrf-token]').attr('content')}
    });
  }
   */

  sendStatus(method) {
    fetch(this.data.get('url'), {
      method: method,
      headers: {'Accept':'application/json, text/html', 'Content-Type':'application/json', 'X-Requested-With':'XMLHttpRequest'},
      body: JSON.stringify({authenticity_token: this.token})
    }).then(response => {
      if (response.status === 200) {
        this.checkTarget.classList.toggle('complete');
      }
    });
  }
}